import React from "react";
import i18next from "i18next";
import { Controller, useFormContext } from "react-hook-form";
import {
  FormHelperText,
  TextField,
} from "@mui/material";
import { get as lodashGet } from "lodash";
import useStyles from "style/js-style/containers/administration/roles/dialogsStyle";

const RoleStandardInput = ({
  fieldName,
  isRequired = false,
  placeholder = '',
  label = '',
  variant = 'standard', //mui text field variant
  onChange = () => { },
  validate = () => { return null }
}) => {
  const { classes } = useStyles();
  const formMethods = useFormContext();
  const {
    control,
    formState: { errors },
    trigger,
    clearErrors,
  } = formMethods;

  return (
    <>
      <span className={classes.label}>
        {label}
      </span>
      <Controller
        control={control}
        name={fieldName}
        rules={{
          validate: (value) => {
            if (isRequired) {
              const isEmpty = !value || value.length === 0;
              if (isEmpty) {
                return i18next.t("infos.required");
              } else {
                clearErrors(fieldName);
              }
            }

            return validate(value);
          }
        }}
        render={({ field }) => (
          <TextField
            {...field}
            id={`${fieldName}-input-id`}
            type={"text"}
            variant="outlined"
            error={!!lodashGet(errors, `${fieldName}`)}
            fullWidth
            className={classes.inputText}
            onChange={(e) => {
              formMethods.setValue(fieldName, e.target.value);
              onChange(e.target.value);
              trigger(fieldName);
            }}
            value={formMethods.getValues(fieldName)}
            placeholder={placeholder}
          />
        )}
      />

      {
        !!lodashGet(errors, `${fieldName}`) && (
          <FormHelperText className="Mui-error" style={{ position: "relative" }}>
            {lodashGet(errors, `${fieldName}.message`)}
          </FormHelperText>
        )
      }
    </>
  );
}

export default RoleStandardInput;
